import { WINDOW_LOAD } from '../actions/windowEvents';

export default function reducer(state = { isLoaded: false }, action = {}) {
  switch (action.type) {
    case WINDOW_LOAD:
      return {...state, isLoaded: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/window.js